import { storeToRefs } from 'pinia'

import * as mutationTypes from './mutation-types'
import api from '../api/comment'
import { useAssistantChecksStore } from '@app/application/sf-assistant-checks/stores/assistant-checks'
import { useSfAssistantChecksCommentIds } from '@app/application/sf-assistant-checks/stores/assistant-checks-comment-ids'

const Comments = {
  state() {
    return {
      comments: {},
    }
  },

  getters: {
    commentsByIds: (state) => (ids) => {
      return ids.map((id) => state.comments[id])
    },

    commentById: (state) => (id) => {
      return state.comments[id]
    },
  },

  mutations: {
    [mutationTypes.SET_COMMENTS](state, comments) {
      state.comments = comments
    },

    [mutationTypes.ADD_COMMENT](state, { comment, commentable, type }) {
      if (type === 'AssistantCheck') {
        const assistantChecksCommentIdsStore = useSfAssistantChecksCommentIds()
        const { addCommentId } = assistantChecksCommentIdsStore

        addCommentId(String(commentable.id), String(comment.id))
      } else {
        commentable.commentIds.push(comment.id)
      }

      state.comments[comment.id] = comment
    },

    [mutationTypes.EDIT_COMMENT](state, { comment }) {
      state.comments[comment.id] = comment
    },
  },

  actions: {
    async postComment(
      { commit, dispatch, rootGetters, rootState },
      [commentableId, type, params]
    ) {
      let mutation
      let commentable
      let elementType = 'remark'

      const assistantChecksStore = useAssistantChecksStore()
      const { checkReadStatus, assistantChecks } =
        storeToRefs(assistantChecksStore)

      switch (type) {
        case 'Remark':
          mutation = mutationTypes.REMOVE_NEW_COMMENT_REMARK_ID
          commentable = rootGetters.remarkById(commentableId)
          break
        case 'AssistantCheck': {
          mutation = mutationTypes.REMOVE_NEW_COMMENT_ASSISTANT_CHECK_ID
          commentable = assistantChecks.value[commentableId]
          elementType = 'assistant-check'
          break
        }
        default:
          mutation = mutationTypes.REMOVE_NEW_COMMENT_CHECK_ID
          commentable = rootGetters.checkById(commentableId)
          break
      }

      const comment = await api.postComment(
        commentableId,
        type,
        params,
        rootState.companyId ||
          rootState.notifications?.activeCompanyId ||
          Silverfin.currentCompanyId
      )

      if (type === 'AssistantCheck' && !checkReadStatus.value[commentableId]) {
        assistantChecksStore.markAsRead([commentableId])
      }

      commit(mutationTypes.ADD_COMMENT, { comment, commentable, type: type })

      dispatch('fetchCommunication')
      dispatch(
        'fetchNotifications',
        rootState.companyId ||
          rootState.notifications?.activeCompanyId ||
          Silverfin.currentCompanyId
      )
      window.eventHub.$emit('scrollToElement', {
        elementType: elementType,
        elementId: commentableId,
      })

      window.eventHub.$emit('highlightAssistantCheck', commentableId)

      window.eventHub.$emit('resetNotificationCount')
      window.eventHub.$emit('postComment', comment.id)
      commit(mutation, { id: commentableId })

      return comment
    },

    async editComment(
      { commit, dispatch, rootState },
      [commentableId, type, commentId, params]
    ) {
      const comment = await api.editComment(
        commentableId,
        type,
        commentId,
        params,
        rootState.companyId ||
          rootState.notifications?.activeCompanyId ||
          Silverfin.currentCompanyId
      )

      commit(mutationTypes.EDIT_COMMENT, { comment })

      dispatch('fetchCommunication')
      window.eventHub.$emit('scrollToElement', {
        elementType: type.toLowerCase(),
        elementId: commentableId,
      })
      window.eventHub.$emit('editComment', commentId)
      commit(mutationTypes.REMOVE_EDIT_COMMENT_ID, { id: commentId })

      return comment
    },

    async removeComment(
      { dispatch, rootState },
      [commentableId, commentableType, commentId]
    ) {
      await api.destroyComment(
        commentId,
        rootState.companyId ||
          rootState.notifications?.activeCompanyId ||
          Silverfin.currentCompanyId,
        commentableType,
        commentableId
      )
      await dispatch('fetchCommunication')
      window.eventHub.$emit('removeComment', commentId)
    },
  },
}

export default Comments
